import {Component, input, output} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'registration-button',
  standalone: true,
  imports: [ NgClass ],
  templateUrl: './registration-button.component.html',
  styleUrl: './registration-button.component.scss'
})
export class RegistrationButtonComponent {
    subtitle = input.required<string>();
    isActive = input(false);
    isModule = input(false);
    buttonClick = output<void>();
}
